import { CampaignApiError } from '@bingads-webui-campaign/api-errors';
import { GENERIC_ERROR_MESSAGE_KEY } from '../shared/constants';

export const ERROR_ENTITY = {
  Campaign: 'campaign',
  AssetGroup: 'assetGroup',
  CampaignLocation: 'campaignLocation',
  CampaignRadius: 'campaignRadius',
  CampaignNegativeLocation: 'campaignNegativeLocation',
  CampaignLocationIntent: 'campaignLocationIntent',
  CampaignDayTimeCriterion: 'campaignDayTimeCriterion',
  CampaignNegativeWebpage: 'campaignNegativeWebpage',
  AudienceGroupAssetGroupAssociation: 'audienceGroupAssetGroupAssociation',
  BrandListAssociation: 'brandListAssociation',
};

export const apiErrorMapper = campaignApiError => (campaignApiError &&
  (campaignApiError.isHtmlMessage ?
    { DangerousHtmlMessage: campaignApiError.message } :
    campaignApiError.message || campaignApiError.code || campaignApiError.toString())) || '';

export const genericApiError = new CampaignApiError(GENERIC_ERROR_MESSAGE_KEY);
